import { BASE_URL } from 'constants/api';

/**
 * Fetch a single teacher-classroom by ID.
 */
export const getTeacherClassroom = async teacherClassroomId => {
  const response = await fetch(
    `${BASE_URL}/classroom/teacher-classroom/${teacherClassroomId}/`,
    {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch classroom: ${response.status}`);
  }

  return response.json();
};

/**
 * Fetch the summary for a teacher-classroom (teacher name, student logs, call logs).
 */
export const getTeacherClassroomSummary = async teacherClassroomId => {
  const response = await fetch(
    `${BASE_URL}/classroom/teacher-classrooms/${teacherClassroomId}/summary/`,
    {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch classroom summary: ${response.status}`);
  }

  return response.json();
};
